'use client';

import { useTranslations } from 'next-intl';
import { cn } from '@bazaar-marketplace/utils';
import type { SaleButtonStatus } from './sale-buy-button';
import { SvgClock } from '~/components/icons/clock';
import { SvgHourglass } from '@bazaar-marketplace/assets/hourglass';

interface SaleStatusProps {
  status: SaleButtonStatus;
  timeText: string;
}

export const SaleStatus = ({ status, timeText }: SaleStatusProps) => {
  const t = useTranslations('directSale');

  if (status === 'sold-out' || status === 'ended') {
    return null;
  }

  if (status === 'soon') {
    return (
      <div className="text-[14px] font-bold leading-[1.3] text-white/80">
        <div className="flex items-center gap-1">
          <SvgClock />
          {t('startsIn', { time: timeText })}
        </div>
      </div>
    );
  }

  const gradientClassName =
    'bg-clip-text text-transparent bg-[linear-gradient(88.36deg,#5B93EB_0.02%,#69EF89_25.01%,#F7E78F_50%,#F796BC_74.99%,#987DF2_99.98%)]';

  return (
    <div className={cn('text-[14px] font-bold leading-[1.3]', gradientClassName)}>
      <div className="flex items-center gap-1">
        <SvgHourglass className="text-[#5D9FDE] translate-y-[-1px]" />
        {t('endsIn', { time: timeText })}
      </div>
    </div>
  );
};
